import { createTheme } from "@mui/material/styles";

// Extend Material-UI's theme type to include the custom `atomic` palette
declare module "@mui/material/styles" {
  interface Palette {
    atomic: {
      // Reds
      red5: string;
      red4: string;
      red3: string;
      red2: string;
      red1: string;
      // Greens
      green4: string;
      green3: string;
      green2: string;
      green1: string;
      // Oranges
      orange1: string;
      // Blues
      blue1: string;
      // Purples
      purple1: string;
    };
  }
  interface PaletteOptions {
    atomic?: {
      // Reds
      red5: string;
      red4: string;
      red3: string;
      red2: string;
      red1: string;
      // Greens
      green4: string;
      green3: string;
      green2: string;
      green1: string;
      // Oranges
      orange1: string;
      // Blues
      blue1: string;
      // Purples
      purple1: string;
    };
  }
}

const ATOMIC_FONT_STACK =
  '"Archivo", "Public Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif';

export const CHAT_FONT_STACK =
  '"Nunito", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", sans-serif';

export const theme = createTheme({
  palette: {
    atomic: {
      // Reds
      red5: "#b15d59",
      red4: "#FA7861",
      red3: "#FA9887",
      red2: "#FCBAAE",
      red1: "#f5dada",
      // Greens
      green4: "#CAFA61",
      green3: "#D5FA87",
      green2: "#E4FCAE",
      green1: "#e3edcc",
      // Oranges
      orange1: "#fff7d9",
      // Blues
      blue1: "#e1ecfa", // light blue
      // Purples
      purple1: "#f3e8fd", // new: muted light purple
    },
    mode: "light", // Set to "dark" for dark mode
  },
  typography: {
    h1: {
      fontSize: "1.5rem",
      fontWeight: 400,
      lineHeight: 1.2,
    },
    fontFamily: ATOMIC_FONT_STACK,
    fontSize: 15,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontFamily: ATOMIC_FONT_STACK,
        },
      },
    },
    MuiPaper: {
      defaultProps: {
        elevation: 0, // Set default elevation to 0
      },
    },
    MuiTable: {
      styleOverrides: {
        root: {
          fontFamily: ATOMIC_FONT_STACK,
          fontSize: "12px",
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          padding: "8px",
          borderBottom: "1px solid #e0e0e0",
          fontSize: "12px",
          fontFamily: ATOMIC_FONT_STACK,
          textWrap: "nowrap",
        },
        head: {
          fontWeight: "bold",
          backgroundColor: "white",
          fontSize: "12px",
          fontFamily: ATOMIC_FONT_STACK,
          textWrap: "nowrap",
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          // height: 40,
        },
      },
    },
  },
});
